import * as Type from './actionsTypes';

const INITIAL_STATE = {
  selectedRequisicao: {},
  catalogoItens: [],
  disponibilidade: null,
  disponibilidadeLoading: false,
  disponibilidadeError: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.REQUISICAO_FIND_ONE_SUCCESS: {
      return {
        ...state,
        selectedRequisicao: action.data,
      };
    }
    case Type.REQUISICAO_CLEAR_SELECTED: {
      return {
        ...state,
        selectedRequisicao: {},
        disponibilidade: null,
        disponibilidadeLoading: false,
        disponibilidadeError: false,
      };
    }
    case Type.REQUISICAO_FETCH_CATALOGO_SUCCESS: {
      return {
        ...state,
        catalogoItens: action.data || [],
      };
    }
    case Type.REQUISICAO_FETCH_DISPONIBILIDADE: {
      return {
        ...state,
        disponibilidade: null,
        disponibilidadeLoading: true,
        disponibilidadeError: false,
      };
    }
    case Type.REQUISICAO_FETCH_DISPONIBILIDADE_SUCCESS: {
      return {
        ...state,
        disponibilidade: action.data || null,
        disponibilidadeLoading: false,
        disponibilidadeError: false,
      };
    }
    case Type.REQUISICAO_FETCH_DISPONIBILIDADE_ERROR: {
      return {
        ...state,
        disponibilidade: null,
        disponibilidadeLoading: false,
        disponibilidadeError: true,
      };
    }
    case Type.REQUISICAO_CLEAR_DISPONIBILIDADE: {
      return {
        ...state,
        disponibilidade: null,
        disponibilidadeLoading: false,
        disponibilidadeError: false,
      };
    }
    default:
      return state;
  }
}

export const getSelectedRequisicao = (state) => state.rootState.requisicao.selectedRequisicao;
export const getCatalogoItens = (state) => state.rootState.requisicao.catalogoItens;
export const getDisponibilidade = (state) => state.rootState.requisicao.disponibilidade;
export const getDisponibilidadeLoading = (state) =>
  state.rootState.requisicao.disponibilidadeLoading;
export const getDisponibilidadeError = (state) =>
  state.rootState.requisicao.disponibilidadeError;
